import { render, staticRenderFns } from "./TheDashboardLayout.vue?vue&type=template&id=582d1e7e"
import script from "./TheDashboardLayout.vue?vue&type=script&lang=js"
export * from "./TheDashboardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports